import { Switch, Route, useLocation } from "react-router-dom";
import { TransitionGroup } from "react-transition-group";
//main
import Dashbord from "../views/Main/Dashbord.js";
import ManagerDashbord from "../views/Main/managerDashbord.js";
import Calendar from "../views/Main/Calendar.js";
// user
import SignUp from "../views/User/Auth/SignUp.js";
import RecoverPassword from "../views/User/Auth/RecoverPassword.js";
//App
import UserProfile from "../views/User/UserManagement/UserProfile.js";
import UserAdd from "../views/User/UserManagement/UserAdd.js";
import UserList from "../views/User/UserManagement/UserList.js";
import UserPrivacySetting from "../views/User/UserManagement/UserPrivacySetting.js";
import UserAccountSettingList from "../views/User/UserManagement/UserAccountSetting.js";
import ChangePassword from "../views/User/UserManagement/changePassword.js";
import PermissionList from "../views/User/UserManagement/Permission.js";
import Chat from "../views/App/Chat.js";
import Todo from "../views/App/Todo.js";
// Employee
import Employee from "../views/HR/Employee/Employee.js";
import Employeeadd from "../views/HR/Employee/Employeeadd.js";
import Employeeview from "../views/HR/Employee/Employeeview.js";
import Employeeedit from "../views/HR/Employee/Employeeedit.js";
import EmployeeEducationadd from "../views/HR/Employee/EmployeeEducatioadd.js";
import EmployeeExperienceadd from "../views/HR/Employee/EmployeeExperienceadd.js";
import EmployeeReference from "../views/HR/Employee/EmployeeReference.js";
import EmployeeReferenceadd from "../views/HR/Employee/EmployeeReferenceadd.js";

//branch
import Branch from "../views/HR/Employee/Branch.js";
import BranchView from "../views/HR/Employee/branchview";

//labor
import LaborList from "../views/HR/Employee/LaborList.js";
import LaborAdd from "../views/HR/Employee/Labboradd.js";
import AddLabortoProject from "../views/HR/Attendance/add-labors-to-project.js";
import CreatLaborAtendanceSheet from "../views/HR/Attendance/labor-list-tocreat-sheet.js";
// project
import TaskAssignment from "../views/Project/taskAssignment.js";
import Taskview from "../views/Project/Taskview.js";
import taskList from "../views/Project/tasklist.js";
import BranchStock from "../views/Project/Branch_level_stock.js";
import BranchEmployeeAssignment from "../views/Project/branch-emp-task-assignment.js";
import ekycDevices from "../views/Project/ekycdevices";
import mytaskList from "../views/Project/my_tasklist.js";
import mytaskstatus from "../views/Project/myTaskStatus";
import taskAprovalRequests from "../views/Project/task_approval_requeests.js";
import adminTaskReport from "../views/Project/admin-task-report";
import taskTarget from "../views/Project/task_target.js";
import AdminBranchTargetConfig from "../views/Project/Admin_Branch_target_config.js";
import BranchStockAssignment from "../views/Project/branch-stock-assignment.js";
import attendance from "../views/HR/Employee/attendance.js";
import adminAttendanceReport from "../views/HR/Employee/admin-attendance-report.js";
import attendanceReport from "../views/HR/Employee/branch-attendance-report.js";
import registerTaskReport from "../views/HR/Employee/RegisterTaskReport.js";
//attendance
import Laborattendance from "../views/HR/Attendance/labor_attendance_sheet.js";
import AttendanceRecordForm from "../views/HR/Attendance/record-attendace.js";
import AttendanceList from "../views/HR/Attendance/attendance_list_view.js";
import RejectedAttendanceList from "../views/HR/Attendance/rejected_attendance_list_view.js";
import PrepareAttendancePaymentSheet from "../views/HR/Attendance/attendance_payment_preparation.js";
//payroll
import SalaryScale from "../views/Payroll/PayrollScale/scale";
import EmployeePayroll from "../views/Payroll/employeePayroll.js";
import PayrollEdit from "../views/Payroll/payrollEdit.js";
import CreatPayrollSheet from "../views/Payroll/createPayrollSheet.js";
import Benefit from "../views/Payroll/Benefit/benefit.js";
import Deduction from "../views/Payroll/Deduction/deduction.js";
// finance
import Expense from "../views/Finance/expense.js";
import ExpenseCategory from "../views/Finance/expense_category.js";
import PaymentMethod from "../views/Finance/payment_method";

//Extrapages
import Timeline1 from "../views/Pages/Timeline/Timeline1.js";
import Pricing1 from "../views/Pages/Pricing/Pricing1.js";
import FAQ from "../views/Pages/FAQ.js";
import BlankPage from "../views/Pages/BlankPage.js";
import TermsOfUse from "../views/Pages/Extrapages/TermsOfUse.js";
import PrivacyPolicy from "../views/Pages/Extrapages/PrivacyPolicy.js";
import IMSRoutes from "./ims-routes.js";

const Layout1Route = () => {
  let location = useLocation();
  return (
    <TransitionGroup>
      <Switch location={location}>
        <Route path="/" exact component={ManagerDashbord} />

        <Route path="/admin-dashboard" exact component={Dashbord} />
        {/* App */}
        <Route path="/user-profile" component={UserProfile} />
        <Route path="/user-add" component={UserAdd} />
        <Route path="/user-list" component={UserList} />
        <Route path="/user-privacy-setting" component={UserPrivacySetting} />
        <Route
          path="/user-account-setting"
          component={UserAccountSettingList}
        />
        <Route path="/change-password" component={ChangePassword} />
        <Route path="/chat" component={Chat} />
        <Route path="/todo" component={Todo} />
        <Route path="/auth/sign-up" component={SignUp} />
        <Route path="/recoverpw" component={RecoverPassword} />
        <Route path="/permission-list" component={PermissionList} />

        {/*empplyee*/}
        <Route path="/employee" component={Employee} />
        <Route path="/employee-add" component={Employeeadd} />
        <Route path="/employee-view" component={Employeeview} />
        <Route path="/employee-edit" component={Employeeedit} />
        <Route
          path="/employee-education-add"
          component={EmployeeEducationadd}
        />
        <Route path="/employee-attendance" component={attendance} />
        <Route path="/attendance-report" component={attendanceReport} />
        <Route
          path="/admin-attendance-report"
          component={adminAttendanceReport}
        />

        <Route
          path="/employee-experience-add"
          component={EmployeeExperienceadd}
        />
        <Route path="/employee-reference" component={EmployeeReference} />
        <Route
          path="/employee-reference-add"
          component={EmployeeReferenceadd}
        />

        {/*branch */}
        <Route path="/branch" component={Branch} />
        <Route path="/branch-view" component={BranchView} />

        {/*labor */}
        <Route path="/labor" component={LaborList} />
        <Route path="/labor-add" component={LaborAdd} />
        <Route path="/add-labors-to-project" component={AddLabortoProject} />

        {/*project   */}
        <Route path="/employee-task-assignment" component={TaskAssignment} />
        <Route
          path="/branch-employee-assignment"
          component={BranchEmployeeAssignment}
        />

        <Route path="/branch-ekyc-devices" component={ekycDevices} />
        <Route path="/branch-stock" component={BranchStock} />
        <Route path="/task-view" component={Taskview} />
        <Route path="/task-list" component={taskList} />
        <Route path="/task-approval-request" component={taskAprovalRequests} />
        <Route path="/my-tasks" component={mytaskList} />
        <Route path="/my-task-status" component={mytaskstatus} />
        <Route path="/task-target" component={taskTarget} />
        <Route path="/admin-task-report" component={adminTaskReport} />

        <Route
          path="/branch-target-config"
          component={AdminBranchTargetConfig}
        />
        <Route
          path="/branch-stock-assignment"
          component={BranchStockAssignment}
        />

        <Route path="/register-task-report" component={registerTaskReport} />

        {/*attendance*/}
        <Route
          path="/create-labor-attendance-sheet"
          component={CreatLaborAtendanceSheet}
        />
        <Route
          path="/rejected-labor-attendance-list"
          component={RejectedAttendanceList}
        />
        <Route path="/labor-attendance-sheet" component={Laborattendance} />
        <Route path="/attendance-record" component={AttendanceRecordForm} />
        <Route path="/attendance-list-view" component={AttendanceList} />
        <Route
          path="/attendance/payment-sheet/prepare"
          component={PrepareAttendancePaymentSheet}
        />
        {/* payrooll */}
        <Route path="/payroll/salary-scale" component={SalaryScale} />
        <Route path="/payroll/employee-payroll" component={EmployeePayroll} />
        <Route path="/payroll/edit-payroll" component={PayrollEdit} />
        <Route
          path="/payroll/creat-payroll-sheet"
          component={CreatPayrollSheet}
        />
        <Route path="/payroll/benefit" component={Benefit} />
        <Route path="/payroll/deduction" component={Deduction} />

        {/* finance */}
        <Route path="/finance/expense" component={Expense} />
        <Route path="/finance/expense-category" component={ExpenseCategory} />
        <Route path="/finance/payment-method" component={PaymentMethod} />

        {/* Extrapages */}
        <Route path="/timeline-1" component={Timeline1} />
        <Route path="/pricing-1" component={Pricing1} />
        <Route path="/pages-faq" component={FAQ} />
        <Route path="/pages-blank-page" component={BlankPage} />
        <Route path="/terms-of-service" component={TermsOfUse} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />

        {/* Caldenar */}
        <Route path="/calendar" component={Calendar} />

        {/* IMS Routes it must be after all routes*/}
        <IMSRoutes />
      </Switch>
      {/* </CSSTransition> */}
    </TransitionGroup>
  );
};

export default Layout1Route;
